module.exports = __webpack_public_path__ + "static/media/content.9b314629.png";